import { useAlert } from './useAlert'
export const useError = () => {
   const { alertWarn, alertError } = useAlert()
   const validarErro = (error) => {
      const erro = error.response.data
      let mensagem = ''

      if (typeof erro !== 'string' && erro !== undefined) {
         if (erro.mensagens) {
            const { descricao } = erro.mensagens[0]
            mensagem = descricao
         } else {
            const resposta = { ...erro.errors }
            for (const prop in resposta) {
               if (Object.prototype.hasOwnProperty.call(resposta, prop)) {
                  mensagem = resposta[prop][0]
               }
            }
         }

         return alertWarn(mensagem)
      } else {
         return alertError('Erro Interno')
      }
   }

   return {
      validarErro
   }
}
